import { IProduto, IProdutoRow, TipoDesconto } from "pages/registra-venda/registra-venda.model";
import { calcularValorDesconto, getValorTotalLiquido } from "utils/desconto-utils";

export const criarProdutoRow = (
    produto: IProduto,
    percentualDescontoFixo: number,
    uuidAutorizadorDesconto: string | null,
    brinde: boolean,
    isTroca: boolean,
    somarValorBrindeTotalNota: boolean,
    uuid: string
): IProdutoRow => {
    if (brinde) {
        const zeraValorPorBrinde = !somarValorBrindeTotalNota;
        return {
            produto,
            quantidade: 1,
            estoque: -1,
            valorTotal: zeraValorPorBrinde ? 0 : produto.preco,
            itemDesconto: {
                percentualDesconto: 0,
                tipoDesconto: TipoDesconto.PERCENTUAL,
                uuidAutorizador: null,
                valorDesconto: 0,
            },
            brinde,
            isTroca,
            uuid,
        };
    }

    const valorDesconto = calcularValorDesconto(produto.preco, percentualDescontoFixo);
    return {
        produto,
        quantidade: 1,
        estoque: -1,
        valorTotal: getValorTotalLiquido(1, produto.preco, valorDesconto),
        itemDesconto: {
            percentualDesconto: percentualDescontoFixo,
            tipoDesconto: TipoDesconto.PERCENTUAL,
            uuidAutorizador: percentualDescontoFixo > 0 ? uuidAutorizadorDesconto : null,
            valorDesconto,
        },
        brinde,
        isTroca,
        uuid,
    };
};
